export default function componentConstructor(hasPermission) {
  return {
    name: 'PermissionManager',

    componentName: 'PermissionManager',

    props: {
      latchkey: {
        type: [String, Array],
        required: true,
        default: ''
      },
      // and 或者 or
      type: {
        type: String,
        default: 'and'
      }
    },

    data() {
      return {}
    },

    functional: true,

    render(h, ctx) {
      const getChildren = () => {
        // 没有子元素
        if (!Array.isArray(ctx.children) || ctx.children.length === 0) return null

        // 没有权限
        if (
          !hasPermission(ctx.props.latchkey, ctx.props.type)
        ) {
          const children = ctx.children.filter(item => {
            if (item.data && item.data.slot && item.data.slot === 'backup') {
              return true
            }
            return false
          })
          // 没权限返回 slot backup
          return children.length > 0 ? children : null
        }

        const children = ctx.children.filter(item => {
          // 有权限返回除了 slot backup 外的内容
          if (item.data && item.data.slot && item.data.slot === 'backup') {
            return false
          }
          return true
        })

        return children.length > 0 ? children : null
      }

      return getChildren()
    }
  }
}
